export const UnavailabilityItemOrigin = {
  MENU_UNAVAILABLE: 'MENU_UNAVAILABLE',
  PART_UNAVAILABLE: 'PART_UNAVAILABLE',
  PRODUCT_UNAVAILABLE: 'PRODUCT_UNAVAILABLE',
  OPTION_UNAVAILABLE: 'OPTION_UNAVAILABLE',
}

export const ORDER_PREVIEW_DELAY = 500
